import { DATATRANSFER_INIT_LOADING, DATATRANSFER_INIT_SUCCESS, DATATRANSFER_INIT_FAIL } from '@/store/types'

export const dataTransfer = {
  [DATATRANSFER_INIT_LOADING](state) {
    state.dataTransferSettings.init = 0
    state.dataTransferSettings.initErr = []
    state.dataTransferSettings.menu = {}
  },
  [DATATRANSFER_INIT_SUCCESS](state, data) {
    state.dataTransferSettings.init = 1
    state.dataTransferSettings.initErr = []
    state.dataTransferSettings.menu = data.menu
  },
  [DATATRANSFER_INIT_FAIL](state, error) {
    state.dataTransferSettings.init = 2
    state.dataTransferSettings.initErr = error
    state.dataTransferSettings.menu = {}
  }
}
